import type {
  CreateVesselDryDockInput,
  CreateVesselHullEventInput,
  VesselDryDock,
  VesselHullEvent,
} from "../models/uw-ops.models";

export const isIsoDate = (value: string): boolean => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const parsed = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
};

export const validateDryDockInput = (
  input: CreateVesselDryDockInput,
  rows: VesselDryDock[],
  isEdit: boolean,
): string | null => {
  if (!input.dryDockDate) return "Dry-dock date is required.";
  if (!isIsoDate(input.dryDockDate)) return "Dry-dock date must be a valid date.";
  if (!input.antifoulingApplicationDate) return "Antifouling application date is required.";
  if (!isIsoDate(input.antifoulingApplicationDate)) return "Antifouling application date must be a valid date.";
  if (!input.nextPlannedDryDockDate) return "Next planned dry-dock date is required.";
  if (!isIsoDate(input.nextPlannedDryDockDate)) return "Next planned dry-dock date must be a valid date.";
  if (input.antifoulingApplicationDate < input.dryDockDate) {
    return "Antifouling application date must be the same as or after the dry-dock date.";
  }
  if (input.nextPlannedDryDockDate <= input.dryDockDate) {
    return "Next planned dry-dock date must be after the dry-dock date.";
  }
  if (!input.place?.trim()) return "Place is required.";
  if (!input.paintVendor?.trim()) return "Paint vendor is required.";
  if (!input.flatBottomPaint?.trim()) return "Flat-bottom paint is required.";
  if (!input.verticalSidePaint?.trim()) return "Vertical-side paint is required.";
  if (!input.bootTopPaint?.trim()) return "Boot-top paint is required.";
  if (input.paintSchemePurpose && !/^[1-9]\d{0,2}$/.test(input.paintSchemePurpose.trim())) {
    return "Paint Scheme Service life must be a whole number between 1 and 999 months.";
  }
  if (!isEdit && rows.some((row) => row.dryDockDate.slice(0, 10) === input.dryDockDate)) {
    return "A dry-dock record already exists for this date.";
  }
  return null;
};

export const validateHullEventInput = (
  input: CreateVesselHullEventInput,
  rows: VesselHullEvent[],
  isEdit: boolean,
): string | null => {
  if (!input.eventDate || !input.eventType) return "Event date and type are required.";
  if (!isIsoDate(input.eventDate)) return "Event date must be a valid date.";
  if (
    !isEdit &&
    rows.some((row) => row.eventDate.slice(0, 10) === input.eventDate && row.eventType === input.eventType)
  ) {
    return "A hull event already exists for this date and type.";
  }
  return null;
};
